import axios from 'axios';

const requestProductsType = 'REQUEST_PRODUCTS';
const receiveProductsType = 'RECEIVE_PRODUCTS';
const initialState = { products: [], isLoading: false };

export const actionCreators = {
  requestProducts: () => async (dispatch, getState) => {

    dispatch({ type: requestProductsType });

    const url = '/products';
    const response = await axios(url);
    const products = response.data;

    dispatch({ type: receiveProductsType, products });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestProductsType) {
    return {
      ...state,
      isLoading: true
    };
  }

  if (action.type === receiveProductsType) {
    return {
      ...state,
      products: action.products,
      isLoading: false
    };
  }

  return state;
};
